import * as d3 from 'd3-interpolate';
export function hexColors(shift = 0) {
    const colors = ['#1866b4', '#f79319', '#cc4300', '#00c180', '#d70947', '#772acb', '#087783', '#2531d4', '#921473', '#3c6372', '#d62f2f', '#144b7f'];
    const tmp = [...colors, ...colors].splice(shift);
    return tmp;
}
export function hexColorsGradient(ctx, opt) {
    var _a, _b;
    console.log('height', opt.height);
    const shift = (_a = opt === null || opt === void 0 ? void 0 : opt.shift) !== null && _a !== void 0 ? _a : 0;
    const gradientLerp = Number((_b = new URLSearchParams(location.search).get('lerp')) !== null && _b !== void 0 ? _b : '0.5');
    console.log('gradientLerp', gradientLerp);
    const colors = hexColors().map(startColor => {
        const colorInterpolator = d3.interpolateRgb(startColor, '#ffffff');
        const endColor = colorInterpolator(gradientLerp);
        const gradient = ctx.createLinearGradient(0, 0, 0, opt.height);
        gradient.addColorStop(0.0, startColor);
        gradient.addColorStop(1.0, endColor);
        return gradient;
    });
    const tmp = [...colors, ...colors].splice(shift);
    return tmp;
}
//# sourceMappingURL=colors.js.map